function createId() {
  return (Math.random() * 0x7FFFFFFF | 0).toString();
}

export { createId };
//# sourceMappingURL=createId.js.map
